import Dexie from "dexie";
import global from "@/prototype/global.js";

// import {get_translation} from "svg-utils";

const log = global.log.getLogger("f_mtac.utils.json");
log.setLevel(log.levels.WARN);

export const json_deep_clone = (object) => {
    return Dexie.deepClone(object);
};

export const json_get_path = (object, path) => {
    // http://www.w3.org/TR/IndexedDB/#steps-for-extracting-a-key-from-a-value-using-a-key-path
    if (path in object) {
        return object[path];
    }
    if (!path) {
        return object;
    }
    if (typeof path !== "string") {
        let rv = [];
        for (let n = 0, l = path.length; n < l; ++n) {
            let value = json_get_path(object, path[n]);
            rv.push(value);
        }
        return rv;
    }
    let period = path.indexOf(".");
    if (period === -1) {
        return undefined;
    }
    let inner_object = object[path.substr(0, period)];
    if (inner_object === undefined) {
        return undefined;
    }
    return json_get_path(inner_object, path.substr(period + 1));
};

const set_object_key_value = (object, key, value) => {
    if (value !== undefined) {
        object[key] = value;
        return;
    }
    if (Array.isArray(object) && !isNaN(parseInt(key))) {
        object.splice(key, 1);
    } else {
        delete object[key];
    }
};

export const json_set_path = (object, path, value) => {
    if (!object || path === undefined){
        return;
    }
    if ("isFrozen" in Object && Object.isFrozen(object)) {
        return;
    }
    let period = path.indexOf(".");
    if (period === -1) {
        return set_object_key_value(object, path, value);
    }
    let current_path = path.substr(0, period);
    let remaining_path = path.substr(period + 1);
    if (remaining_path === "") {
        return set_object_key_value(object, current_path, value);
    }
    let inner_object = object[current_path];
    if (!inner_object) {
        inner_object = (object[current_path] = {});
    }
    json_set_path(inner_object, remaining_path, value);
};

export const json_del_path = (object, path) => {
    json_set_path(object, path, undefined);
};

export const json_apply_modifications = (object, prefix, modifications) => {
    var modified = 0;
    log.debug(`JSON.json_apply_modifications = ${JSON.stringify(modifications)}`);
    // applying modifications in reverse order, so that it would be possible
    // to remove elements in arrays without changing order
    var modifications_keys = Object.keys(modifications).sort().reverse();
    log.debug("JSON.json_apply_modifications keys", modifications_keys);
    prefix = prefix ? prefix + "." : "";
    for (let key of modifications_keys) {
        if (!key.startsWith(prefix)) {
            continue;
        }
        let path = key.substr(prefix.length);
        json_set_path(object, path, modifications[key]);
        modified += 1;
    }
    return modified;
};

export const json_deflate = (object, prefix = false, result = null) => {
    result = result || {};

    // preserve empty objects and arrays, they are lost otherwise
    if (prefix && typeof object === "object" && object !== null && Object.keys(object).length === 0) {
        result[prefix] = Array.isArray(object) ? [] : {};
        return result;
    }

    prefix = prefix ? prefix + "." : "";

    for (const key in object) {
        if (Object.prototype.hasOwnProperty.call(object, key)) {
            if (typeof object[key] === "object" && object[key] !== null) {
                // recursion on deeper objects
                json_deflate(object[key], prefix + key, result);
            } else {
                result[prefix + key] = object[key];
            }
        }
    }
    return result;
};

export const json_inflate = (object) => {
    const result = {};
    for (const key in object) {
        if (!Object.prototype.hasOwnProperty.call(object, key)) {
            continue;
        }
        // just a complicated regex to only match a single dot in the middle of the string
        const keys = key.match(/^\.+[^.]*|[^.]*\.+$|(?:\.{2,}|[^.])+(?:\.+$)?/g);
        keys.reduce((r, e, j) => {
            return r[e] || (r[e] = isNaN(Number(keys[j + 1])) ? (keys.length - 1 === j ? object[key] : {}) : []);
        }, result);
    }
    return result;
};
